import { Component } from "@angular/core"
import { ViewController } from "ionic-angular"

@Component({
  selector: "notifications-settings-page",
  templateUrl: "notifications.html",
})
export class NotificationsSettingsPage {

  constructor(
    private viewCtrl: ViewController
  ) {}

  ionViewWillEnter() {

    this.viewCtrl.setBackButtonText("Ajustes")
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/notifications.ts